import {
  type Framework,
  WorkspaceScope,
  WorkspaceService,
} from '@toeverything/infra';

import { FavoriteService } from '../favorite';
import { ActionItemsService } from './services/action-items-service';
import {
  CompatibleFavoriteItemsAdapter,
  MigrationFavoriteItemsAdapter,
  WorkspacePropertiesAdapter,
} from './services/adapter';
import { AttendeesService } from './services/attendees-service';
import { AugmentationStatusService } from './services/augmentation-status-service';
import { FollowupEmailService } from './services/followup-email-service';
import { WorkspaceLegacyProperties } from './services/legacy-properties';
import { TranscriptionBlobStorage } from './services/transcription-blob-storage';
import { TranscriptionService } from './services/transcription-service';

export { ActionItemsService } from './services/action-items-service';
export {
  CompatibleFavoriteItemsAdapter,
  MigrationFavoriteItemsAdapter,
  WorkspacePropertiesAdapter,
} from './services/adapter';
export { AttendeesService } from './services/attendees-service';
export { AugmentationStatusService } from './services/augmentation-status-service';
export { FollowupEmailService } from './services/followup-email-service';
export { WorkspaceLegacyProperties } from './services/legacy-properties';
export type { SerializedTodoItem } from './services/schema';
export { TranscriptionBlobStorage } from './services/transcription-blob-storage';
export { TranscriptionService } from './services/transcription-service';

export function configureWorkspacePropertiesModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(WorkspaceLegacyProperties, [WorkspaceService])
    .service(WorkspacePropertiesAdapter, [WorkspaceService])
    .service(TranscriptionBlobStorage, [WorkspaceService])
    .service(AttendeesService, [WorkspacePropertiesAdapter])
    .service(TranscriptionService, [
      TranscriptionBlobStorage,
      WorkspacePropertiesAdapter,
    ])
    .service(FollowupEmailService, [WorkspacePropertiesAdapter])
    .service(AugmentationStatusService, [WorkspacePropertiesAdapter])
    .service(ActionItemsService, [WorkspacePropertiesAdapter])
    .service(MigrationFavoriteItemsAdapter, [WorkspacePropertiesAdapter])
    .service(CompatibleFavoriteItemsAdapter, [FavoriteService]);
}
